
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface AddCodeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  numCodesToAdd: number;
  setNumCodesToAdd: (value: number) => void;
  onAddCodes: () => Promise<void>;
  isAddingCodes: boolean;
}

export const AddCodeDialog = ({
  isOpen,
  onClose,
  numCodesToAdd,
  setNumCodesToAdd,
  onAddCodes,
  isAddingCodes,
}: AddCodeDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Añadir códigos</DialogTitle>
          <DialogDescription>
            Indica la cantidad de nuevos códigos que deseas generar para este lanzamiento.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Label htmlFor="num-codes">Cantidad de códigos a añadir</Label>
          <Input 
            id="num-codes" 
            type="number" 
            min="1" 
            max="100" 
            value={numCodesToAdd} 
            onChange={e => setNumCodesToAdd(parseInt(e.target.value) || 1)} 
            className="mt-2" 
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isAddingCodes}>
            Cancelar
          </Button>
          <Button onClick={onAddCodes} disabled={isAddingCodes || numCodesToAdd <= 0}>
            {isAddingCodes ? "Añadiendo..." : "Añadir códigos"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
